export default "__VITE_ASSET__CWjwak5H__"